import { Form, FormInstance } from "antd";
import { useCallback, useEffect } from "react";
import { DOCX_TYPE } from "../../../../../../../../../../../lib/constants";
import ReportService from "../../../../../../../../../../../services/reportGeneration";
import BackGroundService from "../../../../../../../../../../../services/background";

export const useUpdateAttachments = (
  form: FormInstance,
  contractId: string,
  setGlobalIsLoading: (value: boolean) => void
) => {
  const templateId = Form.useWatch("templateId", form);

  const setError = useCallback(
    (value: string[]) => {
      form.setFields([
        {
          name: "templateId",
          errors: value,
        },
      ]);
    },
    [form]
  );

  const onFail = useCallback(() => {
    setGlobalIsLoading(false);
    setError(["Generation failed"]);
  }, [setError, setGlobalIsLoading]);

  const getStatus = useCallback(
    async (id: string) => {
      try {
        const res = await BackGroundService.getProgress(id);

        const { status, result } = res;

        if ([6, 4].includes(status)) {
          if (status === 4) {
            if (result.succesfulCount === 1) {
              setGlobalIsLoading(false);

              const value = {
                response: result.additionalData.ResultFileItemId,
                name: result.additionalData.ResultFileName,
                type: DOCX_TYPE,
                status: "done",
                size: result.additionalData.ResultFileSizeBytes,
                taskId: id,
              };

              const attachments = form.getFieldValue("attachments");

              if (attachments) {
                const res = [...attachments];

                const attachedIndex = res.findIndex(
                  (item: any) => item.response === value.response
                );

                if (attachedIndex === -1) {
                  res.push(value);

                  form.setFieldValue("attachments", res);
                }
              } else {
                form.setFieldValue("attachments", [value]);
              }
            } else {
              setGlobalIsLoading(false);
              setError(["Generation failed"]);
            }
          }

          status === 6 && onFail();
        } else {
          setTimeout(async () => {
            await getStatus(id);
          }, 1000);
        }
      } catch {
        onFail();
      }
    },
    [form, onFail, setError, setGlobalIsLoading]
  );

  const generate = useCallback(async () => {
    if (templateId) {
      setError([]);
      setGlobalIsLoading(true);

      const reportId: string = await Promise.resolve(
        ReportService.generateEmailLetterReport(templateId, contractId)
      );

      await getStatus(reportId);
    }
  }, [templateId, setError, setGlobalIsLoading, contractId, getStatus]);

  useEffect(() => {
    generate();
  }, [generate]);
};
